"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectRehydrated = void 0;
var selectRehydrated = function (_a) {
    var rehydrated = _a.rehydrated;
    return rehydrated;
};
exports.selectRehydrated = selectRehydrated;
//# sourceMappingURL=rehydrated.selectors.js.map